// src/web/AppWeb.jsx
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AllBookListWeb from './pages/allBookListWeb';

export default function AppWeb() {
  return (
    <BrowserRouter basename="/web">
      <Routes>
        <Route path="/all" element={<AllBookListWeb />} />
      </Routes>
    </BrowserRouter>
  );
}
